<i
  class="go-icon"
  [ngClass]="classObject"
>
  {{ icon }}
</i>
